export default __webpack_public_path__ + "static/media/CREW-logo.f70f9274.svg";